import React from 'react';
import { DetailPanelData } from '../../../Common/DetailPanel';
import { FormatDate } from '../../../../utils';
import { Box } from '@mui/material';

const AdditionalInformation = ({
    data
}) => {
    return (
        <>
            <DetailPanelData id='CreatedByHeader' title="CREATED BY" data={data.createdByName} />
            <DetailPanelData id='LastUpdatedByHeader' title="LAST UPDATED BY" data={data.updatedByName} />
            <Box sx={{ visibility: 'hidden', display: { xs: 'none', md: 'block' } }}>blank</Box>
            <DetailPanelData id='CreatedOnHeader' title="CREATED ON" data={FormatDate(data.createDate)} />
            <DetailPanelData id='LastUpdatedOnHeader' title="LAST UPDATED ON" data={FormatDate(data.updateDate)} />
            <Box sx={{ visibility: 'hidden', display: { xs: 'none', md: 'block' } }}>blank</Box>
        </>
    )
}

export default AdditionalInformation;